/* eslint-disable react-hooks/rules-of-hooks */
import React, { useContext } from 'react';
import { ThemeContext } from 'providers/ThemeProvider';
import { Header } from 'components/theme';
import { Container } from 'components/common';
import { useIntl, Link, FormattedMessage } from 'gatsby-plugin-intl';
import { StaticQuery, graphql } from 'gatsby';
import Img from 'gatsby-image';
import { ContactImage } from 'components/theme/ContactImage';
import { ContactMaps } from 'components/theme/ContactMaps';

import {
  Wrapper,
  IntroWrapper,
  IntroNew,
  Details,
  Thumbnail,
  Tel,
  Email,
  IntroDrTitle,
  IntroDrSubtitle,
  Behandlung,
  Address,
  ContactImageMapsWrapper,
  ContactImageWrapper,
  ContactMapsWrapper,
} from './styles';

export const Intro = () => {
  const { theme } = useContext(ThemeContext);

  return (
    <StaticQuery
      query={graphql`
        query IntroQuery {
          file(relativePath: { eq: "intro_bg.png" }) {
            childImageSharp {
              # Specify the image processing specifications right in the query.
              fluid {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
      `}
      render={data => (
        <Wrapper>
          <Header />
          <IntroWrapper as={Container}>
            <Thumbnail>
              <Img fluid={data.file.childImageSharp.fluid} alt="dr. Kereszty Praxis, dentalmikroskop" />
              <IntroDrTitle>
                <FormattedMessage id="intro.dr.title" />
              </IntroDrTitle>
              <IntroDrSubtitle>
                <FormattedMessage id="intro.dr.subtitle" />
              </IntroDrSubtitle>
            </Thumbnail>
            <Details theme={theme}>
              <Address>
               <a
                  href="https://www.google.com/maps/place/Sopron,+Kis+J%C3%A1nos+u.+3,+9400/@47.6817279,16.58541,17z/data=!3m1!4b1!4m6!3m5!1s0x476c3ca674a0240d:0x98d4e82a3782d734!8m2!3d47.6817279!4d16.5879849!16s%2Fg%2F11j8sk_70m?entry=ttu&g_ep=EgoyMDI2MDExMy4wIKXMDSoASAFQAw%3D%3D"
                  title={useIntl().formatMessage({ id: 'seo.title' })}
                  target="blank"
                >
                  <IntroNew><FormattedMessage id="intro.new" /></IntroNew><IntroNew><FormattedMessage id="intro.new.addresse" /></IntroNew>
                </a>
              </Address>
              
              <Tel>
                <a href="tel:+36706111427">+36 70 6111427</a>
              </Tel>
              <Email>
                <a href="mailto:office@dental-profi.eu">office@dental-profi.eu</a>
              </Email>
              <Behandlung>
                <h3>
                  <FormattedMessage id="footer.behandlungtitle" />
                </h3>
                <ul>
                  <li>
                    <Link to="/implantat">
                      <FormattedMessage id="footer.behandlung.1" />
                    </Link>{' '}
                    /{' '}
                  </li>
                  <li>
                    <Link to="/krone">
                      <FormattedMessage id="footer.behandlung.2" />
                    </Link>{' '}
                    /{' '}
                  </li>
                  <li>
                    <Link to="/digitezaleahnheilkunde">
                      <FormattedMessage id="footer.behandlung.4" />
                    </Link>{' '}
                    /{' '}
                  </li>
                  <li>
                    <Link to="/dentalmikroskop">
                      <FormattedMessage id="footer.behandlung.5" />
                    </Link>
                  </li>
                </ul>
              </Behandlung>
            </Details>
          </IntroWrapper>
          <ContactImageMapsWrapper>
            <ContactImageWrapper>
              <ContactImage />
            </ContactImageWrapper>
            <ContactMapsWrapper>
              <ContactMaps />
            </ContactMapsWrapper>
          </ContactImageMapsWrapper>
        </Wrapper>
      )}
    />
  );
};
